<template>
  <div class="rule-interval-wrapper row">
    <div class="col-md-6">
      <b-form-group
        :state="$_hasError('interval')"
        class="optimizer-form-group"
        label="Considering data from"
        :invalid-feedback="$_getError('interval')"
      >
        <vue-opti-select-light
          class="optimizer-select w-100"
          name="interval"
          data-vv-as="Interval"
          v-validate="'required'"
          data-vv-validate-on="input|update"
          data-vv-value-path="$c_model"
          :value="interval.input"
          @change="(option) => { interval.input = option.value }"
          :options="options.intervals"
          label-key="text"
          single
          button-block
        />
      </b-form-group>
    </div>
    <div class="col-md-6">
      <b-form-group
        class="optimizer-form-group"
        label="Exclude days from interval"
      >
        <vue-opti-select-light
          class="optimizer-select w-100"
          name="interval_exclude"
          data-vv-as="Interval Exclude"
          v-validate="'required'"
          data-vv-validate-on="input|update"
          data-vv-value-path="$c_model"
          :options="options.intervalsExclude"
          :disabled="!state.interval_exclude"
          :value="interval.interval_exclude"
          @change="(option) => { interval.interval_exclude = option.value }"
          label-key="text"
          single
          button-block
        />
      </b-form-group>
    </div>
  </div>
</template>

<script>
import component from '../mixins/component';

export default {
  name: 'RuleInterval',
  mixins: [component],
  props: {
    value: { type: Object, default: () => ({ input: '', interval_exclude: '0' }) },
  },
  data() {
    return {
      interval: {
        input: '',
        interval_exclude: '0',
      },
      options: {
        intervals: [],
        intervalsExclude: [],
      },
      state: {
        interval_exclude: false,
      },
    };
  },
  watch: {
    interval: {
      immediate: true,
      handler() {
        this.$_emit('interval');
      },
      deep: true,
    },
    'interval.input': function (value) {
      if (value === '0' || value === '-1') {
        this.interval.interval_exclude = '0';
        this.state.interval_exclude = false;
      } else if (!this.state.interval_exclude) this.state.interval_exclude = true;
    },
  },
  created() {
    this.interval = this.value;
    this.options.intervals = this.config.intervalsConfig.intervals;
    this.options.intervalsExclude = this.config.intervalsConfig.intervalsExclude;
  },
  methods: {
  },
};
</script>

<style lang="scss">
.rule-interval-wrapper {
  .optimizer-form-group {
    margin-bottom: .8rem;
    margin-top: .8rem;
  }
}
</style>
